import { IncidentSeverity, type IncidentSeverityValues } from '@lmc/ts-common'
import type { TFunction } from 'i18next'
import { incidentReportsConstants } from 'locale/incidentReports'

/**
 * gets a number and transforms it into IncidentSeverity value
 */
const getIncidentSeverityByIndex = (
  incidentSeverityIndex: number
): IncidentSeverity => {
  switch (incidentSeverityIndex) {
    case 1:
      return IncidentSeverity.level1
    case 2:
      return IncidentSeverity.level2
    case 3:
      return IncidentSeverity.level3
    case 4:
      return IncidentSeverity.level4
    case 5:
      return IncidentSeverity.level5
    default:
      return IncidentSeverity.level1
  }
}

export const getIncidentSeverityDefaultValue = (
  index: number | IncidentSeverity,
  t: TFunction
): string => {
  const incidentSeverity: IncidentSeverity = getIncidentSeverityByIndex(index)
  const constant: `SEVERITY_LEVEL_${IncidentSeverity}` =
    incidentReportsConstants[
      `SEVERITY_LEVEL_${incidentSeverity}`
    ] as `SEVERITY_LEVEL_${IncidentSeverity}`

  return t(constant)
}

export const getIncidentReportSeverityLabel = (
  severity: IncidentSeverity,
  severities: IncidentSeverityValues | undefined,
  t: TFunction
): string => {
  // set customSeverity to the custom value chosen by the user
  const customSeverity: string | undefined = severities?.[severity]

  // if we have severities, and if the value chosen by the user is not undefined or empty string
  if (severities && customSeverity) {
    return customSeverity
  }

  const defaultSeverity: string = getIncidentSeverityDefaultValue(severity, t)

  return defaultSeverity
}

export const getSeverityOptions = (
  severities: IncidentSeverityValues | undefined,
  t: TFunction
) => {
  const allSeveritiesArray: IncidentSeverity[] = [
    IncidentSeverity.level1,
    IncidentSeverity.level2,
    IncidentSeverity.level3,
    IncidentSeverity.level4,
    IncidentSeverity.level5
  ]

  const severitiesValues = allSeveritiesArray.map((severity) => {
    const severityLabel = getIncidentReportSeverityLabel(
      severity,
      severities,
      t
    )

    return {
      value: severity,
      label: severityLabel
    }
  })

  return severitiesValues
}
